import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import LeftHalfLayout from '../../../layouts/buy/LeftHalfLayout'

const Amount = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 15px;
  line-height: 30px;
  color: ${({ theme }) => theme.colors.blackPearlBlue.shade700};
  font-weight: 500;
`

export interface TotalSummarySectionProps {
  amount: string | number | React.ReactNode
  className?: string
  name: string
  labelEndAdornment?: React.ReactNode
}

const TotalSummarySection: React.FC<TotalSummarySectionProps> = ({
  className,
  name,
  amount,
  labelEndAdornment,
}) => (
  <Grid className={className} container item justifyContent="space-between" xs={12}>
    <Grid item>
      <Typography variant="body2" gutterBottom>
        {`${name}`}
        {labelEndAdornment}
      </Typography>
    </Grid>
    <Grid item>
      <Amount>{amount}</Amount>
    </Grid>
  </Grid>
)

const StyledTotalSummarySection = styled(TotalSummarySection)`
  ${LeftHalfLayout} & {
    padding-left: 15px;
    padding-right: 15px;
  }
`

export default StyledTotalSummarySection
